var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 89,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.48 17.244c23.483-22.992 61.557-22.992 85.04 0l2.827 2.767a2.9 2.9 0 0 1 0 4.163l-9.668 9.466a1.526 1.526 0 0 1-2.126 0l-3.89-3.808c-16.382-16.04-42.944-16.04-59.326 0l-4.165 4.078a1.526 1.526 0 0 1-2.126 0l-9.668-9.466a2.9 2.9 0 0 1 0-4.163l3.102-3.037ZM134.515 36.82l8.604 8.425a2.899 2.899 0 0 1 0 4.163l-38.798 37.988a3.052 3.052 0 0 1-4.252 0L72.532 60.435a.763.763 0 0 0-1.063 0l-27.537 26.96a3.052 3.052 0 0 1-4.252 0L.88 49.409a2.9 2.9 0 0 1 0-4.163l8.605-8.425a3.052 3.052 0 0 1 4.252 0L41.275 63.78a.763.763 0 0 0 1.063 0L69.874 36.82a3.052 3.052 0 0 1 4.252 0l27.537 26.961a.763.763 0 0 0 1.063 0l27.537-26.96a3.052 3.052 0 0 1 4.252 0Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletConnect);
export default __webpack_public_path__ + "static/media/wallet-connect.47bb1c45bc1278f95d761c6ab6ce3d86.svg";
export { ForwardRef as ReactComponent };